import React from "react";
import Beneficiaries from "./Beneficiaries";
import dp2 from "../images/2.jpg";
import dp3 from "../images/3.jpg";
import dp4 from "../images/4.jpg";
import { selectBeneficiaries } from "../features/beneficiaries/beneficiariesSlice";
import { useSelector } from "react-redux";

const FavBenficiaries = () => {
  const beneficiariesList = useSelector(selectBeneficiaries);
  const beneficiaries = beneficiariesList?.memberList;
  // console.log(beneficiaries[0]);
  return (
    <div
      className="flex bg-white text-[#14B084] w-1/4 px-2 pb-5 pt-2 rounded-lg justify-center 
mr-4 flex-col"
    >
      <h3 className="card__title font-semibold text-xl ">
        Favourite Beneficiaries
      </h3>

      {/* <Beneficiaries img={dp2} name="Dad" accountNumber="103829482" />
        <Beneficiaries img={dp4} name="Mom" accountNumber="103829482" />
        <Beneficiaries
          img={dp3}
          name="GoodWill Industries"
          accountNumber="103829482"
          isLast="true"
        /> */}
      {beneficiaries?.map((beneficiary, index) => (
        <div key={index} className="mt-2">
          <Beneficiaries
            img={beneficiary.img}
            name={beneficiary.relation}
            accountNumber={beneficiary.memberAccount}
            isLast={index === beneficiaries.length - 1}
          />
        </div>
      ))}

      <button className="card__button bg-gradient-to-r from-[#008556] to-[#14B084] text-white text-center rounded-2xl text-sm py-2 font-medium ml-auto px-4 ">
        View All
      </button>
    </div>
  );
};

export default FavBenficiaries;
